import LeaderBoardView from "./LeaderBoardView"

export default  LeaderBoardView;
